import request from '@/utils/request'

// 获取个人信息
export const userInfoApi = ()=>{
	return request("/getInfo","GET")
}
//隐私政策 用户协议 关于卫灿
export const protocol = (data) => {
	return request('/app/protocolManage/list', data, "get")
}
//验证码登录
export const codeLoginApi = data =>{
	return request('/pcSmsLogin',data,"POST")
}
//密码登陆
export const passwordLoginApi = data =>{
	return request('/pcLogin',data,"POST")
}
// 退出登录
export const exitLoginApi = ()=>{
	return request('/logout',null,"POST")
}
// 获取验证码
export const getCodeApi = (a,b,c) =>{
	return request(`/getPcSmsCode?phone=${a}&code=${b}&uuid=${c}`,"get")
}
// 获取图形验证码
export const getCodeImgApi = ()=>{
	return request('/captchaImage',null,"GET")
}
// 微信登录
export const wxLoginApi = data=>{
	return request('/pcLoginByWeixinV2',data,"post")
}